<template>
  <div class="rules-accept">
    <p class="mt-1">{{$t('components.Profile.ruleAccept.title')}}:</p>

    <p class="my-1">
      <v-modal block-scroll :full="!screen.breakPoint.tabPort" :no-background="!screen.breakPoint.tabPort" no-padding min-width="65rem">
        <template v-if="this.reqCountry.USA" v-slot:activator="{ on }">
          - <a href="/statics/documents/terms-of-service.html" @click.prevent.stop="on">{{ $t('components.Profile.ruleAccept.termsOfUse') }}</a> <br>
        </template>
        <template v-else-if="this.reqCountry.MEXICO" v-slot:activator="{ on }">
          - <a href="/statics/documents/Terms_of_Service_Spanish.pdf" @click.prevent.stop="on">{{ $t('components.Profile.documentsAccept.termsOfService') }}</a> <br>
        </template>

        <template v-slot:header>{{ $t('components.Profile.ruleAccept.termsOfUse') }}</template>

        <template v-if="this.reqCountry.USA" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/terms-of-service.html" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          </div>
        </template>
        <template v-else-if="this.reqCountry.MEXICO" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe  src="/statics/documents/Terms_of_Service_Spanish.pdf" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          </div>
        </template>
      </v-modal>

      <v-modal block-scroll :full="!screen.breakPoint.tabPort" :no-background="!screen.breakPoint.tabPort" no-padding min-width="65rem">
        <template v-if="this.reqCountry.USA" v-slot:activator="{ on }">
          - <a href="/statics/documents/cookie-policy.html" @click.prevent.stop="on">{{$t('components.Profile.ruleAccept.cookiePolicy')}}</a> <br>
        </template>
        <template v-else-if="this.reqCountry.MEXICO" v-slot:activator="{ on }">
          - <a href="/statics/documents/Cookie_Policy_SPAN.pdf" @click.prevent.stop="on">{{ $t('components.Profile.documentsAccept.cookiePolicy') }}</a> <br>
        </template>

        <template v-slot:header>{{$t('components.Profile.ruleAccept.cookiePolicy')}}</template>

        <template v-if="this.reqCountry.USA" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/cookie-policy.html" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          </div>
        </template>
        <template v-else-if="this.reqCountry.MEXICO" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/Cookie_Policy_SPAN.pdf" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          </div>
        </template>
      </v-modal>

      <v-modal block-scroll :full="!screen.breakPoint.tabPort" :no-background="!screen.breakPoint.tabPort" no-padding min-width="65rem">
        <template v-if="this.reqCountry.USA" v-slot:activator="{ on }">
          - <a href="/statics/documents/privacy-policy.html" @click.prevent.stop="on">{{$t('components.Profile.ruleAccept.privacyPolicy')}}</a> <br>
        </template>
        <template v-else-if="this.reqCountry.MEXICO" v-slot:activator="{ on }">
          - <a href="/statics/documents/Politica_de_privacidad.pdf" @click.prevent.stop="on">{{ $t('components.Profile.documentsAccept.privacyPolicy') }}</a> <br>
        </template>

        <template v-slot:header>{{$t('components.Profile.ruleAccept.privacyPolicy')}}</template>

        <template v-if="this.reqCountry.USA" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/privacy-policy.html" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          </div>
        </template>
        <template v-else-if="this.reqCountry.MEXICO" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/Politica_de_privacidad.pdf" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          </div>
        </template>
      </v-modal>
    </p>

    <p class="mt-2 mb-3">
      <v-checkbox type="boxed" v-model="model" val="agree">{{ $t('components.Profile.ruleAccept.readAndAgreeTerms') }}</v-checkbox>
      <span class="text-color-error" v-if="error">{{error}}</span>
    </p>
  </div>
</template>

<script>
import vCheckbox from '@/ui/controls/vCheckbox'
import vModal from '@/ui/modals/vModal'

import screen from '@/mixins/screen'

export default {
  mixins: [screen],

  props: {
    value: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: null
    },

    reqCountry: Object
  },

  components: {
    vCheckbox,
    vModal
  },

  computed: {
    model: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
